import * as PropTypes from 'prop-types'
import classNames from 'classnames'

export class AudioAnimation extends React.PureComponent {
  static propTypes = {
    isPlaying: PropTypes.bool
  }

  static defaultProps = {
    isPlaying: true
  }

  render () {
    const {
      isPlaying
    } = this.props

    return (
      <button className={classNames(
        'c-audio-animation',
        { 'c-audio-animation--is-playing': isPlaying }
      )}>
        {[1, 2, 3].map((index) => (
          <span className='c-audio-animation__bar' key={index} />
        ))}
      </button>
    )
  }
}
